import React from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import { GoogleOAuthProvider } from '@react-oauth/google';
import { render } from 'react-dom';
import { QueryClientProvider } from '@tanstack/react-query';
import { queryClient } from './services/queryClient';
import './index.css';
import { AppConfigProvider } from './components/web/AppConfigContext';
import App from './pages/Web/App';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import reportWebVitals from './reportWebVitals';

const root = document.getElementById('root') as HTMLElement;
const googleClientId = (process.env.REACT_APP_GOOGLE_CLIENT_ID || '').trim();

const appContent = (
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <AppConfigProvider>
        <App />
      </AppConfigProvider>
    </QueryClientProvider>
  </React.StrictMode>
);

// Only wrap with GoogleOAuthProvider when client ID is set (avoids "Missing required parameter: client_id")
render(
  <Router>
    {googleClientId ? (
      <GoogleOAuthProvider clientId={googleClientId}>{appContent}</GoogleOAuthProvider>
    ) : (
      appContent
    )}
  </Router>,
  root
);
// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://cra.link/PWA
serviceWorkerRegistration.register();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
